/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTempAddShapeSquarePlus: {
  name: 'temp-add-shape-square-plus';
  data: string;
} = {
  name: 'temp-add-shape-square-plus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M19 1a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0V5h-1a1 1 0 1 1 0-2h1V2a1 1 0 0 1 1-1ZM4 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-9a1 1 0 1 0-2 0v9H4V5h9a1 1 0 1 0 0-2H4Z" fill="currentColor"/></svg>`,
};
